import { styled } from '@mui/material/styles';

export const ForgotPasswordContainer = styled('div')`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
`;
